<template>

  <video ref="videoPlayer" class="video-js vjs-16-9" muted autoplay></video>

</template>

<script>


  import VimmiPlayer from 'vimmi-player/build/player.cjs';
  import Config from "../../service/config";
  import {normDomain} from "vimmi-web-utils/cjs/normDomain";
  import {PLAYER_EVENTS} from "vimmi-web-utils/cjs/postMessage";

  export default {
    name: "VimmiPlayer",
    props: {
      aspectRatio: {
        type: Boolean,
        default: true
      },
      activeChannel: {
        type: Object
      }
    },
    data() {
      return {
        vimmiPlayer: null
      }
    },
    mounted() {

      this.play();
    },
    watch: {
      activeChannel: {
        handler: function (newval) {
          if (newval) {
            this.play(newval)
          }
        }
      }
    },
    methods: {
      getPlayerHeight() {
        return this.vimmiPlayer.vjsPlayer ? this.vimmiPlayer.vjsPlayer.el_.clientHeight : null
      },
      async play() {
        if (!this.vimmiPlayer) {
          await this.initVimmiPlayer({
            useTag: this.$refs.videoPlayer,
          });
        }
        this.vimmiPlayer.playVideo({
          "isLive": true,
          "itype": 'item_live',
          extraData: {
            poster: this.activeChannel.backdrop,
          },
          playerOptions: {
            muted: true,
            autoplay: true,
          },
          playback_url: this.activeChannel.playback_url + '&tuid=' + Config.get('app_instance_token') + (Config.get('target_site') ? '&target_site=' + normDomain(Config.get('target_site')) : ''),
        });
      },

      async initVimmiPlayer(options = {}) {
        if (this.vimmiPlayer) {
          console.warn('The VimmiPlayer already initialized!');
          return;
        }
        return new Promise((resolve) => {
          this.vimmiPlayer = new VimmiPlayer('olympic-player' + Math.ceil(Math.random() * 100000), {
            initEmpty: true,
            hotkeys: true,
            backend: Config.get('language'),
            mute: true,
            lang: Config.get('language'),
            customer: 'ais',
            ...options
          });
          this.vimmiPlayer.on(PLAYER_EVENTS.READY, () => {
            // this.vimmiPlayer.vjsPlayer.vhs.options_.externHls.GOAL_BUFFER_LENGTH = 1;
            // this.vimmiPlayer.vjsPlayer.vhs.options_.externHls.MAX_GOAL_BUFFER_LENGTH  = 1;
            this.vimmiPlayer.vjsPlayer.on(['touch', 'click'], () => {
              this.$emit('click');
            })
            this.vimmiPlayer.vjsPlayer.one('play', () => {
              this.$emit('onLoaded');
            })
            resolve(this.vimmiPlayer);
          })
        })
      },
    }
  }
</script>

<style lang="scss">
  .video-js {
    width: inherit;
    height: inherit;
    border-radius: 8px;

    .vjs-tech, .vjs-poster, .vjs-big-play-button-block, .vjs-control-bar, .vjs-modal-dialog {
      border-radius: 10px;
    }

    //.vjs-modal-dialog, .vjs-tech {
    //  border-radius: 8px;
    //  word-break: break-all;
    //  white-space: break-spaces;
    //}
  }

</style>
